// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/crud/announce_crud_service_generated.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Announce } from "../../../entity/announce_pb";

/**
 * IndexAnnounceArgs メッセージ
 *
 * @generated from message service.IndexAnnounceArgs
 */
export class IndexAnnounceArgs extends Message<IndexAnnounceArgs> {
  /**
   * @generated from field: int32 offset = 1;
   */
  offset = 0;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<IndexAnnounceArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexAnnounceArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexAnnounceArgs {
    return new IndexAnnounceArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexAnnounceArgs {
    return new IndexAnnounceArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexAnnounceArgs {
    return new IndexAnnounceArgs().fromJsonString(jsonString, options);
  }

  static equals(a: IndexAnnounceArgs | PlainMessage<IndexAnnounceArgs> | undefined, b: IndexAnnounceArgs | PlainMessage<IndexAnnounceArgs> | undefined): boolean {
    return proto3.util.equals(IndexAnnounceArgs, a, b);
  }
}

/**
 * CreateAnnounceArgs メッセージ
 *
 * @generated from message service.CreateAnnounceArgs
 */
export class CreateAnnounceArgs extends Message<CreateAnnounceArgs> {
  /**
   * @generated from field: repeated entity.Announce announces = 1;
   */
  announces: Announce[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 3 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<CreateAnnounceArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateAnnounceArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "announces", kind: "message", T: Announce, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAnnounceArgs {
    return new CreateAnnounceArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAnnounceArgs {
    return new CreateAnnounceArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAnnounceArgs {
    return new CreateAnnounceArgs().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAnnounceArgs | PlainMessage<CreateAnnounceArgs> | undefined, b: CreateAnnounceArgs | PlainMessage<CreateAnnounceArgs> | undefined): boolean {
    return proto3.util.equals(CreateAnnounceArgs, a, b);
  }
}

/**
 * ReadAnnounceArgs メッセージ
 *
 * @generated from message service.ReadAnnounceArgs
 */
export class ReadAnnounceArgs extends Message<ReadAnnounceArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<ReadAnnounceArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadAnnounceArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadAnnounceArgs {
    return new ReadAnnounceArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadAnnounceArgs {
    return new ReadAnnounceArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadAnnounceArgs {
    return new ReadAnnounceArgs().fromJsonString(jsonString, options);
  }

  static equals(a: ReadAnnounceArgs | PlainMessage<ReadAnnounceArgs> | undefined, b: ReadAnnounceArgs | PlainMessage<ReadAnnounceArgs> | undefined): boolean {
    return proto3.util.equals(ReadAnnounceArgs, a, b);
  }
}

/**
 * UpdateAnnounceArgs メッセージ
 *
 * @generated from message service.UpdateAnnounceArgs
 */
export class UpdateAnnounceArgs extends Message<UpdateAnnounceArgs> {
  /**
   * @generated from field: repeated entity.Announce announces = 1;
   */
  announces: Announce[] = [];

  /**
   * @generated from field: bool allow_missing = 2 [json_name = "allow_missing"];
   */
  allowMissing = false;

  /**
   * @generated from field: bool force_execute = 3 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 4 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<UpdateAnnounceArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateAnnounceArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "announces", kind: "message", T: Announce, repeated: true },
    { no: 2, name: "allow_missing", jsonName: "allow_missing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAnnounceArgs {
    return new UpdateAnnounceArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAnnounceArgs {
    return new UpdateAnnounceArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAnnounceArgs {
    return new UpdateAnnounceArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAnnounceArgs | PlainMessage<UpdateAnnounceArgs> | undefined, b: UpdateAnnounceArgs | PlainMessage<UpdateAnnounceArgs> | undefined): boolean {
    return proto3.util.equals(UpdateAnnounceArgs, a, b);
  }
}

/**
 * DeleteAnnounceArgs メッセージ
 *
 * @generated from message service.DeleteAnnounceArgs
 */
export class DeleteAnnounceArgs extends Message<DeleteAnnounceArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  constructor(data?: PartialMessage<DeleteAnnounceArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteAnnounceArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAnnounceArgs {
    return new DeleteAnnounceArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAnnounceArgs {
    return new DeleteAnnounceArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAnnounceArgs {
    return new DeleteAnnounceArgs().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAnnounceArgs | PlainMessage<DeleteAnnounceArgs> | undefined, b: DeleteAnnounceArgs | PlainMessage<DeleteAnnounceArgs> | undefined): boolean {
    return proto3.util.equals(DeleteAnnounceArgs, a, b);
  }
}

/**
 * IndexAnnounceReply メッセージ
 *
 * @generated from message service.IndexAnnounceReply
 */
export class IndexAnnounceReply extends Message<IndexAnnounceReply> {
  /**
   * @generated from field: repeated entity.Announce announces = 1;
   */
  announces: Announce[] = [];

  constructor(data?: PartialMessage<IndexAnnounceReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexAnnounceReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "announces", kind: "message", T: Announce, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexAnnounceReply {
    return new IndexAnnounceReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexAnnounceReply {
    return new IndexAnnounceReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexAnnounceReply {
    return new IndexAnnounceReply().fromJsonString(jsonString, options);
  }

  static equals(a: IndexAnnounceReply | PlainMessage<IndexAnnounceReply> | undefined, b: IndexAnnounceReply | PlainMessage<IndexAnnounceReply> | undefined): boolean {
    return proto3.util.equals(IndexAnnounceReply, a, b);
  }
}

/**
 * CreateAnnounceReply メッセージ
 *
 * @generated from message service.CreateAnnounceReply
 */
export class CreateAnnounceReply extends Message<CreateAnnounceReply> {
  constructor(data?: PartialMessage<CreateAnnounceReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateAnnounceReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAnnounceReply {
    return new CreateAnnounceReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAnnounceReply {
    return new CreateAnnounceReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAnnounceReply {
    return new CreateAnnounceReply().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAnnounceReply | PlainMessage<CreateAnnounceReply> | undefined, b: CreateAnnounceReply | PlainMessage<CreateAnnounceReply> | undefined): boolean {
    return proto3.util.equals(CreateAnnounceReply, a, b);
  }
}

/**
 * ReadAnnounceReply メッセージ
 *
 * @generated from message service.ReadAnnounceReply
 */
export class ReadAnnounceReply extends Message<ReadAnnounceReply> {
  /**
   * @generated from field: repeated entity.Announce announces = 1;
   */
  announces: Announce[] = [];

  constructor(data?: PartialMessage<ReadAnnounceReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadAnnounceReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "announces", kind: "message", T: Announce, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadAnnounceReply {
    return new ReadAnnounceReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadAnnounceReply {
    return new ReadAnnounceReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadAnnounceReply {
    return new ReadAnnounceReply().fromJsonString(jsonString, options);
  }

  static equals(a: ReadAnnounceReply | PlainMessage<ReadAnnounceReply> | undefined, b: ReadAnnounceReply | PlainMessage<ReadAnnounceReply> | undefined): boolean {
    return proto3.util.equals(ReadAnnounceReply, a, b);
  }
}

/**
 * UpdateAnnounceReply メッセージ
 *
 * @generated from message service.UpdateAnnounceReply
 */
export class UpdateAnnounceReply extends Message<UpdateAnnounceReply> {
  constructor(data?: PartialMessage<UpdateAnnounceReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateAnnounceReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAnnounceReply {
    return new UpdateAnnounceReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAnnounceReply {
    return new UpdateAnnounceReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAnnounceReply {
    return new UpdateAnnounceReply().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAnnounceReply | PlainMessage<UpdateAnnounceReply> | undefined, b: UpdateAnnounceReply | PlainMessage<UpdateAnnounceReply> | undefined): boolean {
    return proto3.util.equals(UpdateAnnounceReply, a, b);
  }
}

/**
 * DeleteAnnounceReply メッセージ
 *
 * @generated from message service.DeleteAnnounceReply
 */
export class DeleteAnnounceReply extends Message<DeleteAnnounceReply> {
  constructor(data?: PartialMessage<DeleteAnnounceReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteAnnounceReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAnnounceReply {
    return new DeleteAnnounceReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAnnounceReply {
    return new DeleteAnnounceReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAnnounceReply {
    return new DeleteAnnounceReply().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAnnounceReply | PlainMessage<DeleteAnnounceReply> | undefined, b: DeleteAnnounceReply | PlainMessage<DeleteAnnounceReply> | undefined): boolean {
    return proto3.util.equals(DeleteAnnounceReply, a, b);
  }
}

